import { useNavigate } from "react-router-dom";

import {
  PinInput,
  PinInputField,
  Text,
  Button,
} from "@chakra-ui/react";
import { PhoneIcon } from '@chakra-ui/icons'

import "./aouth.css";
import "./aouthDark.css";
import { useEffect, useRef, useState } from "react";
import axios from "axios"

import { useToast } from '@chakra-ui/react'
import logo from "../../../img/LogoU.png"
import logosvg from "../../../img/LogoUSvg.svg"

import { useSelector } from "react-redux";
import 'react-phone-number-input/style.css'
import PhoneInput, { formatPhoneNumber, formatPhoneNumberIntl, isValidPhoneNumber, isPossiblePhoneNumber } from 'react-phone-number-input'


import ru from 'react-phone-number-input/locale/ru'
import sockets from "../../../socket/socket";


let thisDark = localStorage.getItem("isDark");
const socket = sockets
export default function Outh() {
  const [isSending, setIsSending] = useState(false);
  const [inptValue, setinptValue] = useState("");
  const [loading, setloading] = useState(false);
  const [inpDisapled, setInpDisapled] = useState(false);
  const [value, setValue] = useState()
  const [isValid, setisValid] = useState(false)
  const [pohoneNumber, setPohoneNumber] = useState(null);
  const navigate = useNavigate()
  const toast = useToast({ position: 'top' })
  const focus = useRef(null)
  const [isDark, setIsDark] = useState(false)
  const [country, setcountry] = useState("RU")
  const getDarkModoe = useSelector(darkModes => darkModes)
  const [showErrorText, setShowErrorText] = useState(false)
  const inputRef = useRef(null)
  const [location, setLocation] = useState(null);

  useEffect(() => {

    if (isSending) {
      setIsSending(true)
      setInpDisapled(true)
      setloading(true)
      setinptValue("")

      axios.post('/pincode/v2/api', {
        pinCode: inptValue
      })
        .then(function (response) {

          socket.emit('pushmyid', response.data.datas._id);
          setIsSending(false)
          setInpDisapled(false)
          setloading(false)
          if (response.data.authorization) {
            navigate("/")
          }
        })
        .catch(function (error) {
          console.log(error);
          setIsSending(false)
          setInpDisapled(false)
          setloading(false)
          toast({
            title: error.response.data.message,
            description: error.response.data.message,
            status: "error",
            duration: 2000,
            isClosable: true,

          })
        });
    }
  }, [isSending])

  useEffect(() => {

    setIsDark()

    setIsDark(JSON.parse(thisDark))
  }, [])
  useEffect(() => {

    axios.get('/registration/v2/api')
      .then(function (response) {
        // handle success
        console.log(response);
      })
      .catch(function (error) {
        // handle error
        console.log(error);
      })
      .finally(function () {
        // always executed
      });

  }, [])


  const handelPincode = (e) => {

    setinptValue(e)
    //без проверяется если пин-код длина равна 4 тогда отправляется сервер
    if (e.length === 4) {
      console.log("send server");
      setIsSending(true)
      setInpDisapled(true)

    }

  }


  //Вот как мы отправляем номер телефона на сервер, чтобы позвонить нам
  const handleCall = () => {

    let replcaePhone = pohoneNumber.replace(/\+/g, '');
    if (pohoneNumber.length > 0) {
      setloading(true)
      setInpDisapled(true)
      axios.post('/registration/v2/api', {
        tel: replcaePhone
      })
        .then(function (response) {
          console.log(response);
          setloading(false)
          setInpDisapled(false)

          toast({
            title: response.data.info,
            description: "пожалуйста подождите.",
            duration: 2000,
            status: "info",
            isClosable: true,

          })

        })
        .catch(function (error) {

          console.log(error);
          setloading(false)
          setInpDisapled(false)
          toast({
            title: error.response.data.message,
            description: "Попробуйте чуть позже.",
            duration: 2000,
            isClosable: true,
            status: "error"
          })

        });
      console.log("called");
    } else {
      toast({
        title: "ошибка",
        description: "вы не набрали свой номер телефона.",
        status: "error",
        duration: 2000,
        isClosable: true,
        colorScheme: "#5E80E4"
      })
    }

  }

  useEffect(() => {


    if (pohoneNumber && isPossiblePhoneNumber(pohoneNumber)) {

      inputRef.current.style.border = "1px solid #3B79F6"
      inputRef.current.style.outline = "1px solid #3B79F6"
      inputRef.current.style.fontWeight = "bold"
    } else if (pohoneNumber == undefined) {
      console.log("undefinedundefinedundefinedundefined");
      inputRef.current.style.border = "1px solid red"
      inputRef.current.style.outline = "1px solid red"

    }
    else {
      inputRef.current.style.border = "1px solid #a3bff7"
      inputRef.current.style.outline = "1px solid #a3bff7"
      inputRef.current.style.fontWeight = "normal"
    }

  }, [pohoneNumber])
  // автоопределение страны
  useEffect(() => {
    const fetchData = async () => {
      try {
        // Fetch the user's IP address from ipify.org
        const ipResponse = await axios.get('https://api.ipify.org/?format=json');
        const userIp = ipResponse.data.ip;

        // Fetch location information based on the user's IP
        const locationResponse = await axios.get(`https://ipinfo.io/${userIp}?token=298a6835c8ca73`);
        const { city, region, country, loc } = locationResponse.data;

        // Set the location and country state
        setLocation({ city, region, country, loc });
        setcountry(country);
      } catch (error) {
        // Handle errors
        console.error('Error fetching location:', error);
      }
    };

    fetchData();
  }, []); // Run the effect only once during component mount






  return (
    <div className={isDark ? "aouthContDark" : "aouthCont"}>

      <div>
        <img src={logosvg} alt="" className="iconGlavv" />
      </div>
      <h1 style={{ fontSize: "50px", color: "#5E80E4" }} className={"logoName"}>
        {/* <Stack spacing={3}>
                <Text fontSize="6xl" as={"b"} color={"#5E7DE8"}>Упрости</Text>
                <Stack spacing={3}>
              </Stack>
              </Stack> */}
        УПРОСТИ
      </h1>

      <div className="inputContVerify">

        {(() => {

          if (showErrorText) {


            return <p style={{ color: "red", marginBottom: "10%", justifyContent: "c" }} className="enterPhone">Введите ваш номер телефона</p>
          } else {
            return <p style={{ color: "#5E7DE8", marginBottom: "10%", justifyContent: "c" }} className="enterPhone">Введите ваш номер телефона</p>
          }
        })()}
        {/* <InputGroup className={"phoneINP"}>
          <InputLeftAddon children={"+"} color={"#5E7DE8"} />
          <Input
            type="number"
            placeholder="79000000000"
            value={pohoneNumber}
            borderColor={"#5E7DE8"}
            onChange={(e) => setPohoneNumber(e.target.value)}

          />
        </InputGroup> */}
        <PhoneInput

          ref={inputRef}
          initialValueFormat="national"
          labels={ru}
          className="verifyInput"
          international
          defaultCountry={country}
          limitMaxLength
          placeholder="Введите номер"
          value={pohoneNumber}
          onChange={setPohoneNumber}
          error={pohoneNumber ? (isPossiblePhoneNumber(pohoneNumber) ? undefined : 'Invalid phone number') : 'Phone number required'}
        />





        <p className="wrap" > После нажатия на кнопку вам поступит звонок. Отвечать на звонок не нужно </p>



      </div>
      <div className="btnContAoth">
        {loading ?
          <div className="btnContForCall" style={{ opacity: "0.5" }}>
            <button disabled={inpDisapled || pohoneNumber && isValidPhoneNumber(pohoneNumber) ? false : true} rightIcon={<PhoneIcon />}> Получить звонок</button>
            <span class="material-symbols-outlined">call</span>
          </div>

          :
          <div className="btnContForCall">
            <button onClick={handleCall} colorScheme="blue" background={"#5E7DE8"} width={"270px"} isDisabled={inpDisapled || pohoneNumber && isValidPhoneNumber(pohoneNumber) ? false : true} className={"pinBTN"} rightIcon={<PhoneIcon />}>Получить звонок</button>
            <span class="material-symbols-outlined">call</span>
          </div>
        }
      </div>

      <div className="pinoceInputCont">

        <PinInput type="number" color="#5E7DE8" colorScheme='#5E7DE8' focusBorderColor={"#5E7DE8"} value={inptValue} onChange={(e) => [handelPincode(e)]} isDisabled={inpDisapled} variant="flushed" isRequired={true}>
          <PinInputField width={"60px"} ref={focus} autoFocus={true} />
          <PinInputField width={"60px"} />
          <PinInputField width={"60px"} />
          <PinInputField width={"60px"} />
        </PinInput>




      </div>
      <div>

        <Text fontSize='1xl' color={"#5E7DE8"} >Введите последние 4 цифры номера </Text>


      </div>


    </div>
  );
}
